import * as React from 'react';
import { Link } from '@cian/link-component';
import { parseHtmlEntities } from '../../utils/format';
import * as styles from './slonoTopDescription.css';

interface ISlonoTopDescription {
  description: string;
  link: string;

  onClick(evt: MouseEvent): void;
}

export const SlonoTopDescription = (props: ISlonoTopDescription) => {

  const { description, onClick, link } = props;

  const slicedDescription = parseHtmlEntities(description).slice(0, 270);

  return (
    <div className={ styles['description'] }>
      { slicedDescription }

      {
        description.length > slicedDescription.length &&
        <span>
          ...&nbsp;
          <Link
            href={ link }
            rel="nofollow noopener"
            target="_blank"
            //tslint:disable-next-line:no-any
            onClick={ onClick as any }>
              Подробнее
            </Link>
        </span>
      }
    </div>
  );
};
